import { Slot } from '@radix-ui/react-slot';
import { clsx } from 'clsx';
import { type ComponentPropsWithRef, type ReactNode } from 'react';

import s from './VisuallyHidden.module.css';

interface VisuallyHiddenProps extends ComponentPropsWithRef<'span'> {
  asChild?: boolean;
  children?: ReactNode;
}

/**
 * Deliberately renders even with no children: a live region must already be in
 * the DOM before its text changes, or screen readers announce nothing. Adding an
 * empty-children guard here silently breaks every `aria-live` consumer.
 */
export const VisuallyHidden = (props: VisuallyHiddenProps) => {
  const { asChild = false, children, className, ...attrs } = props;

  const Component = asChild ? Slot : 'span';

  return (
    <Component
      data-vh={true}
      className={clsx(s.visuallyHidden, className)}
      {...attrs}
    >
      {children}
    </Component>
  );
};
